
import {
  passwordStrengthValidator,
  nameAndSurnameValidator,
  cellPhoneValidator,
  CPFValidator,
  CNPJValidator,
  CEPValidator,
  emailValidator
} from 'utils/validator'

const formValidatorMixin = {
  created () {
    this.$validator.extend('isValidPassword', {
      getMessage: field => this.$t('Common.validator.invalidPassword'),
      validate: value => {
        function isValid (text) {
          const rules = passwordStrengthValidator(text)
          return rules.charsCount && rules.lowerCase && rules.upperCase && rules.number && rules.specialChars
        }

        return isValid(value)
      }
    })

    this.$validator.extend('nameAndSurname', {
      getMessage: field => this.$t('Common.validator.invalidNameAndSurname'),
      validate: value => nameAndSurnameValidator(value)
    })

    this.$validator.extend('cellPhone', {
      getMessage: field => this.$t('Common.validator.invalidPhoneNumber'),
      validate: value => cellPhoneValidator(value)
    })

    this.$validator.extend('cpf', {
      getMessage: field => this.$t('Common.validator.invalidCPFNumber'),
      validate: value => CPFValidator(value)
    })

    this.$validator.extend('cnpj', {
      getMessage: field => this.$t('Common.validator.invalidCNPJNumber'),
      validate: value => CNPJValidator(value)
    })

    this.$validator.extend('cep', {
      getMessage: field => this.$t('Common.validator.invalidCEPNumber'),
      validate: value => CEPValidator(value)
    })

    this.$validator.extend('isValidEmail', {
      getMessage: field => this.$t('Common.validator.invalidEmail'),
      validate: value => emailValidator(value)
    })
  }
}

export default formValidatorMixin
